module.exports = __webpack_public_path__ + "static/granulated-4f2e44227ccc3cb28458a95ea4229b11.png";